// extracted by mini-css-extract-plugin
export default {"cls1":"atP5doioF9UTNGiBN0sk","cls2":"YUCsIr5DW9N71HTJmD1i atP5doioF9UTNGiBN0sk"};